import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteAllSuppliers } from "../../api/apiSuppliers";
import toast from "react-hot-toast";

const useDeleteAllSuppliers = () => {
    const queryClient = useQueryClient();

    const { mutate: deleteAllSuppliersMutate, isPending } = useMutation({
        mutationFn: deleteAllSuppliers,
        onSuccess: (res) => {
            toast.success(res.message || "All suppliers deleted successfully");
            queryClient.invalidateQueries({ queryKey: ["suppliers"] });
        },
        onError: (error) => {
            toast.error(error.response?.data?.message || "Failed to delete suppliers");
        },
    });

    return { deleteAllSuppliersMutate, isPending };
};

export default useDeleteAllSuppliers;
